import { getId } from './draftGetters';
import { makeDraftKeyFromId } from './makeDraftKeyFromId';
export const makeDraftKey = (draft, localStorageKeyPrefix) => {
  const id = getId(draft);
  if (id) {
    return makeDraftKeyFromId(id, localStorageKeyPrefix);
  }
  return null;
};